var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.materialRows.length,
          expression: "materialRows.length"
        }
      ]
    },
    [
      _c("div", { staticClass: "form" }, [
        _c("div", { staticClass: "form-body form-horizontal" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "col-md-4 control-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("trans")(
                        "purchase_order.material.table.planned_date"
                      )
                    ) + ":"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-8" },
                  [
                    _c("date-picker", {
                      attrs: {
                        withlabel: false,
                        disabled: _vm.disabled,
                        time: false
                      },
                      model: {
                        value: _vm.formPlannedDate,
                        callback: function($$v) {
                          _vm.formPlannedDate = $$v
                        },
                        expression: "formPlannedDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 pl-0" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.disabled },
                  on: { click: _vm.setPlannedDates }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm._f("trans")(
                          "purchase_order.material.set_planned_dates_button"
                        )
                      ) +
                      "\n                    "
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "view-loader",
              {
                attrs: {
                  loading: _vm.disabled,
                  size: "100px",
                  "show-content": ""
                }
              },
              [
                _c("div", { staticClass: "table-responsive" }, [
                  _c(
                    "table",
                    { staticClass: "table table-bordered table-hover" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticStyle: { "min-width": "250px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.material"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.needed_amount"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isDev
                            ? _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "purchase_order.material.table.comment"
                                    )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "450px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.price_per_kg"
                                )
                              ) + "\n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.to_order"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.unit"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.weight"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.order_weight"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.over_order"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.price_per_unit"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "100px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.amount"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "180px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.planned_date"
                                )
                              ) + "\n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.price_date"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.product_name"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.product_code"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.supplier"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.producer"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "purchase_order.material.table.actions"
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.materialRows, function(materialRow, index) {
                          return _c("tr", { key: index }, [
                            materialRow.type === "defined"
                              ? _c("td", [
                                  _vm._v(_vm._s(materialRow.materialName))
                                ])
                              : _c(
                                  "td",
                                  [
                                    _c("single-select", {
                                      attrs: {
                                        options: _vm.orderableMaterials,
                                        disabled: _vm.disabled,
                                        "open-direction": "top"
                                      },
                                      on: {
                                        dispatch: function($event) {
                                          return _vm.getOffersForMaterials(
                                            index,
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: materialRow.materialId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            materialRow,
                                            "materialId",
                                            $$v
                                          )
                                        },
                                        expression: "materialRow.materialId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("number")(materialRow.quantity, 2)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.isDev
                              ? _c("td", {
                                  domProps: {
                                    innerHTML: _vm._s(materialRow.comment)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("single-select", {
                                  attrs: {
                                    options: materialRow.offerOptions,
                                    disabled: _vm.disabled,
                                    "track-by": "offerId",
                                    label: "optionName",
                                    "sort-by": "kgPrice",
                                    checked: materialRow.selectedOffer,
                                    "allow-empty": false,
                                    "open-direction": "top"
                                  },
                                  on: {
                                    dispatch: function($event) {
                                      return _vm.changeOffer(index, $event)
                                    }
                                  },
                                  model: {
                                    value: materialRow.offer,
                                    callback: function($$v) {
                                      _vm.$set(materialRow, "offer", $$v)
                                    },
                                    expression: "materialRow.offer"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: materialRow.toOrder,
                                    expression: "materialRow.toOrder"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "number",
                                  value: "0",
                                  step: "1",
                                  min: "0",
                                  disabled:
                                    materialRow.supplyWarehouseId !== null ||
                                    _vm.disabled
                                },
                                domProps: { value: materialRow.toOrder },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      materialRow,
                                      "toOrder",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("unit")(
                                    materialRow.offer
                                      ? _vm.getOfferData(index, "unit")
                                      : ""
                                  )
                                ) + "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("number")(
                                      _vm.getOfferData(index, "weight"),
                                      2
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("number")(
                                      materialRow.toOrder *
                                        _vm.getOfferData(index, "weight"),
                                      2
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("number")(
                                      materialRow.toOrder *
                                        _vm.getOfferData(index, "weight") -
                                        materialRow.quantity,
                                      2
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("number")(
                                      _vm.getOfferData(index, "unitPrice"),
                                      2
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("number")(
                                      _vm.getOfferData(index, "unitPrice") *
                                        materialRow.toOrder,
                                      2
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("date-picker", {
                                  attrs: {
                                    disabled: _vm.disabled,
                                    withlabel: false,
                                    time: false
                                  },
                                  model: {
                                    value: materialRow.plannedDate,
                                    callback: function($$v) {
                                      _vm.$set(materialRow, "plannedDate", $$v)
                                    },
                                    expression: "materialRow.plannedDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                _vm._s(_vm.getOfferData(index, "dateString"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                _vm._s(_vm.getOfferData(index, "productName"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getOfferData(index, "offerProductCode")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                _vm._s(_vm.getOfferData(index, "supplierName"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                _vm._s(_vm.getOfferData(index, "producer"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.disabled,
                                    title: _vm._f("trans")("grid.remove")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteRow(index)
                                    }
                                  }
                                },
                                [_c("span", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-10" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  class: _vm.isForecast ? "btn-warning" : "btn-success",
                  attrs: { disabled: _vm.disabled },
                  on: { click: _vm.generatePurchaseOrders }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm._f("trans")(
                          "purchase_order.material.generate" +
                            (_vm.isForecast ? "_forecasts" : "")
                        )
                      ) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.disabled },
                  on: { click: _vm.addNew }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm._f("trans")("purchase_order_item.add_new")) +
                      "\n                "
                  )
                ]
              )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-564c02c9", { render: render, staticRenderFns: staticRenderFns })
  }
}